import { h, Component } from 'preact';
import CorporateMention from './CorporateMention';
import ContactUs from './ContactUs';
import LegalNotices from './LegalNotices';
import {
  IMiniFooterProps, IMiniFooterState,
  ISgwtMiniFooterI18NLanguage
} from '../sgwt-mini-footer.types';
import { SGWT_MINI_FOOTER_I18N } from '../sgwt-mini-footer.i18n';
import { widgetConfiguration } from '@sgwt-widget/core';
import { getInternationalizationLabels } from '../../common/sgwt-widgets-utils';
import { SubscriptionHandle } from '@sgwt-widget/core/lib/bus/Bus';
import { BUS_GLOBAL_LANGUAGE, BUS_USER_CONNECTION, ISgwtUserConnectionStatus } from '../../common/bus-topics';
import { CookiesConsent } from './cookies-consent';
import { AccessibilityLink } from './AccessibilityLink';

export default class SgwtMiniFooter extends Component<IMiniFooterProps, IMiniFooterState> {
  private languageSubscription?: SubscriptionHandle;
  private userConnectionSubscription?: SubscriptionHandle;

  constructor(props: IMiniFooterProps) {
    super(props);
    this.state = this.getInitialState();
  }

  private getInitialState(): IMiniFooterState {
    return {
      language: 'en',
      userConnected: false
    };
  }

  public componentWillMount() {
    // Listen to language modification
    this.languageSubscription = widgetConfiguration().bus
      .subscribe<string>(BUS_GLOBAL_LANGUAGE, language => {
        this.setState({
          language: language
        });
      });

    // Listen to user connection status
    this.userConnectionSubscription = widgetConfiguration().bus
      .subscribe<ISgwtUserConnectionStatus>(BUS_USER_CONNECTION, status => {
        this.setState({
          userConnected: status && status.connected
        });
      });
  }

  public componentWillUnmount() {
    // Unsubscribe to widget bus updates
    if (this.languageSubscription) {
      widgetConfiguration().bus.unsubscribe(this.languageSubscription);
    }
    if (this.userConnectionSubscription) {
      widgetConfiguration().bus.unsubscribe(this.userConnectionSubscription);
    }
  }

  private getSGMarketsLegalNotices(labels: ISgwtMiniFooterI18NLanguage) {
    let notices = undefined;
    if (this.props.mode === 'sg-markets') {
      notices = [];
      for (let link of labels.sgMarketsLink) {
        if (link.type === 'important-notice') {
          // We display the "Important notice" link only when the user is connected (#25).
          if (this.state.userConnected) {
            notices.push(link);
          }
        } else {
          notices.push(link);
        }
      }
    } else if (this.props.cookiesConsent) {
      for (let link of labels.sgMarketsLink) {
        if (link.type === 'cookies-consent') {
          notices = [link];
        }
      }
    }
    return notices;
  }

  render(props: IMiniFooterProps): JSX.Element {
    const currentLanguage = this.state.language || 'en';
    const container = props.container === 'container-fluid' ? 'container-fluid' : 'container';

    const labels: ISgwtMiniFooterI18NLanguage =
      getInternationalizationLabels(SGWT_MINI_FOOTER_I18N, props.additionalI18n, currentLanguage);

    let legalNoticesHTML;
    if (
      props.mode === 'sg-markets' ||
      props.cookiesConsent ||
      (props.legalNotices && Object.keys(props.legalNotices).length)
    ) {
      const SGMarketLegalNotices = this.getSGMarketsLegalNotices(labels);
      const legalNotices = props.legalNotices ? props.legalNotices[currentLanguage] : undefined;
      // Oblige to put test in the parent because if we return only <li></li> tag in children we have
      // a little border at the left of contact us
      legalNoticesHTML =
        <LegalNotices
          label={labels.legalNotices}
          SGMarketLegalNotices={SGMarketLegalNotices}
          legalNotices={legalNotices}
          cookiesConsent={props.cookiesConsent}
        />;
    }

    let accessibilityCompliance = (props.accessibilityCompliance || '').toLowerCase();
    let accessibilityLink = props.accessibilityLink;
    // Default e-accessibility compliance level - restricted to SG Markets for the moment.
    if (props.isSGMarkets) {
      if (!accessibilityCompliance) {
        accessibilityCompliance = 'none';
      }
      if (accessibilityCompliance === 'none' && !accessibilityLink) {
        const lang = currentLanguage === 'fr' ? 'fr' : 'en';
        const url = window.location.protocol + '//' + window.location.host;
        accessibilityLink = `https://shared.sgmarkets.com/accessibility/statement/${lang}.html?redirect_uri=${url}`;
      }
    }

    return (
      <footer class="footerbar">
        <nav class="super-footer mini-footer sgwt-mini-footer">
          <div class={container}>
            {/* Corporate mention */}
            <ul class="nav navbar-nav">
              <CorporateMention label={labels.corporateMention}/>
            </ul>
            <ul class="nav navbar-nav navbar-right">
              <AccessibilityLink
                accessibilityCompliance={accessibilityCompliance}
                accessibilityLink={accessibilityLink}
                onAccessibilityClicked={props.onAccessibilityClicked}
                labels={labels.accessibility}
              />
              {/* Legal notices */}
              { legalNoticesHTML }
              {/* Contact us */}
              <ContactUs
                label={labels.contactUs}
                contactList={props.contactUs}
                contactUsByHelpCenter={props.contactUsByHelpCenter}
              />
            </ul>
          </div>
        </nav>
        { props.cookiesConsent && <CookiesConsent emitUserConsentEvent={props.emitUserConsentEvent} /> }
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/MiniFooter.tsx